__turbopack_context__.v({
  "icon_button": "IconButton-module-scss-module__hXffKW__icon_button",
  "no_outline": "IconButton-module-scss-module__hXffKW__no_outline",
});
